import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ChildCard from './ChildCard';
import Notification from '../../Notification/Notification';
import { UserContext } from '../../../context/UserContext';
import { useFamily } from '../../../context/FamilyContext';
import MyButton from '../../basic/MyButton';
import MySpinner from '../../basic/MySpinner';
import './DashboardViewFamily.css'
import { Link } from 'react-router-dom';

function DashboardViewFamily() {
  const [notification, setNotification] = useState({ message: '', type: '', show: false });
  const { user } = useContext(UserContext);
  const { familyChildren, familyName, refetchFamilyData } = useFamily();
  const location = useLocation();

  const isLoading = !familyName;

  useEffect(() => {
    refetchFamilyData();
  }, [location.pathname, refetchFamilyData]);

  const showNotification = (message, type) => {
    setNotification({ message, type, show: true });
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <MySpinner size="large" color="#0ACF83" />
      </div>
    );
  }

  return (
    <div className="dashboard-frame">
      <div className="top-header">
        <h1>Hey {user.details?.display_name}</h1>
        <h2>Welcome to the {familyName}'s family dashboard!</h2>
        {notification.show && 
          <Notification 
            message={notification.message} 
            type={notification.type} 
            onClose={() => setNotification({ ...notification, show: false })} 
          />
        }
        {familyChildren && familyChildren.length > 0 ? (
          familyChildren.map(child => (
            <ChildCard 
              key={child.childId} 
              child={child} 
              showNotification={showNotification}
            />
          ))
        ) : (
          <div className="empty-dashboard">
            <p>Looks like your family tree is ready to grow! 🌱 Let's add your first family member.</p>
            
            <Link to="/family/manage">
              <MyButton
                text="🌳 Add Your First Family Member"
                backgroundColor="#0ACF83"
                className="add-family-btn"
                hoverBackgroundColor="#007AFF"
                hoverColor="white"
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardViewFamily;